export default __webpack_public_path__ + "static/media/bookmark.032ec417.svg";